export function Footer() {
  return (
    <footer className="bg-brand-gray border-t border-slate-200">
      <div className="max-w-6xl mx-auto px-4 py-5">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <img
            src="/images/JF_logo_01.png"
            alt="J-Frontier"
            className="h-8 w-auto rounded object-cover"
          />

          <div className="flex flex-wrap justify-center gap-5 text-sm">
            <a
              href="https://www.jorudan.co.jp/company/privacy.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-navy/50 hover:text-brand-blue transition-colors"
            >
              プライバシーポリシー
            </a>
            <a
              href="https://www.jorudan.co.jp/company/security.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-brand-navy/50 hover:text-brand-blue transition-colors"
            >
              情報セキュリティポリシー
            </a>
            <p className="text-brand-navy/30 text-xs self-center">
              © 2025 株式会社ジェイフロンティア All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
